module.exports = __webpack_public_path__ + "static/media/bree-win.50801326.jpg";